import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import HomeLoan from "../asset/images/BGImages/home_loan.jpg";
import BusinessLoan from "../asset/images/BGImages/business_loan.jpg";
import PersonalLoan from "../asset/images/BGImages/personal_loan.jpg";
import vehicleLoan from "../asset/images/BGImages/vehicle_loan.jpg";

export default function Services(props) {
    const type = ["home", "vehicle", "personal", "business"]
    return (
        <div className="w-100 d-flex flex-column justify-content-center align-items-center " id="services" style={{ height: "85%", backgroundColor: "#eceff1" }}>
            <h2 className=" display-5 fw-bold text-center theme-color py-3 w-75 mb-4">Our Services</h2>
            <MDBRow className="w-75 mx-0 mb-5" style={{ height: "85%", overflowY: "auto" }} id="lRow">
                {
                    type?.map((e, i) => {
                        return (
                            <MDBCol lg="6" md="6" className="px-2 py-2" key={i} id="serCol">
                                <div className="h-100 w-100 rounded-5 bg-light border position-relative">
                                    <img
                                        src={
                                            e === "home" ?
                                                HomeLoan :
                                                e === "personal" ?
                                                    PersonalLoan :
                                                    e === "vehicle" ?
                                                        vehicleLoan :
                                                        BusinessLoan}
                                        className="rounded-5"
                                        style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                    />
                                    <div className="mask h-100 w-100 d-flex flex-column justify-content-center align-items-center rounded-5"
                                     style={{ backgroundColor: "#00000099" }}>
                                        <h1 className="text-light fw-bold text-capitalize text-center pt-4">{e} Loan</h1>
                                        <p className="text-light px-2 text-wrap w-75" style={{fontSize:"calc(1em + 0.5vmin)"}}>
                                            {
                                                e === "personal" ?
                                                    "Empowering your dreams and aspirations with flexible, quick, and hassle-free personal loans." :
                                                    e === "home" ?
                                                        "Making homeownership a reality with our affordable, transparent, and straightforward home loans." :
                                                        e === "vehicle" ?
                                                            "Drive home your dream vehicle today with our simple, low-interest auto loans." :
                                                            "Nurture your business growth with our tailored, low-interest, and easy-to-access business loans."
                                            }
                                        </p>
                                    </div>
                                </div>
                            </MDBCol>
                        )
                    })
                }

            </MDBRow>
        </div>
    )
}